

import {Component, Vue} from 'vue-property-decorator';
import user_module from '@/modules/user/index'; 



@Component
export default class RegisterSuccess extends Vue {

  beforeMount() {
    
    if (!user_module.lastAccountData){

      this.$router.push('/');
    }
  }

  async register(){

    const response = await user_module.register();

    if (response.result === 'Success'){

      this.$toasted.show(`<b>Success! Check you email</b>`, {
        duration: 3000
      })

    } else if (response.result === "Account with this email already exists, but not activated"){

      this.$toasted.info(`<b>We have already sent you activation link. Please, check your email, include spam</b>`, {
        duration: 8000
      })

    } else {

      this.$toasted.error(response.error, {
        duration: 3000
      })

    }

  }
}

